const carouselData = [
  {
    title: '蜜桃校园特辑',
    subtitle: '青春悸动 · 全系列收录',
    desc: '从经典到新番，校园恋爱蜜桃动漫在线全系列一网打尽。樱花、天台、学园祭——那些让人心跳加速的瞬间，羞羞动漫在线高清播放完整收录。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20beautiful%20school%20campus%20in%20spring%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20anime%20characters%20in%20school%20uniforms%20walking%20along%20a%20path%2C%20warm%20peach%20and%20pink%20color%20palette%2C%20soft%20sunlight%20filtering%20through%20petals%2C%20romantic%20and%20dreamy%20atmosphere%2C%20high%20detail%20anime%20art%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-01-school&orientation=landscape',
    tag: '热门专题',
    color: 'from-primary-500/20 to-accent-500/10',
  },
  {
    title: '奇幻冒险之旅',
    subtitle: '异世界穿越 · 魔法与邂逅',
    desc: '从平凡日常到魔法大陆，羞羞动漫在线观看完整版异世界奇幻系列震撼集结。冒险、成长与浪漫交织，蜜桃动漫在线奇幻专题每日更新。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20fantasy%20world%20with%20floating%20islands%20and%20magical%20energy%2C%20beautiful%20female%20adventurer%20with%20a%20staff%20overlooking%20a%20vast%20landscape%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20epic%20cinematic%20composition%2C%20soft%20ethereal%20glow%2C%20detailed%20anime%20art%20style&width=1200&height=600&seq=carousel-02-fantasy&orientation=landscape',
    tag: '热门专题',
    color: 'from-accent-500/20 to-secondary-500/10',
  },
  {
    title: '新番追更指南',
    subtitle: '48小时同步 · 热门连载全收录',
    desc: '最新蜜桃动漫在线新番48小时内准时上线，羞羞动漫在线新番版块每周更新追更清单。热门连载一集不落，做最快追番的漫迷。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20modern%20cozy%20room%20with%20screens%20displaying%20various%20anime%20characters%2C%20warm%20evening%20lighting%2C%20peach%20and%20rose%20gold%20color%20scheme%2C%20anime%20posters%20on%20walls%2C%20comfortable%20viewing%20atmosphere%2C%20cinematic%20anime%20art%20style%2C%20inviting%20composition&width=1200&height=600&seq=carousel-03-new&orientation=landscape',
    tag: '更新速递',
    color: 'from-secondary-500/20 to-primary-500/10',
  },
  {
    title: '经典蜜桃重温',
    subtitle: '高分神作 · 永不褪色的感动',
    desc: '那些年追过的蜜桃动漫在线经典全收录，羞羞动漫在线观看完整版高分作品一集不落。重温最初的感动与心跳回忆，经典永不褪色。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20with%20nostalgic%20vintage%20aesthetic%2C%20beautiful%20anime%20characters%20in%20retro%20art%20style%2C%20soft%20film%20grain%20and%20warm%20sepia%20tones%2C%20cherry%20blossom%20petals%20floating%2C%20romantic%20nostalgic%20mood%2C%20cinematic%20classic%20anime%20composition%2C%20warm%20peach%20color%20palette&width=1200&height=600&seq=carousel-04-classic&orientation=landscape',
    tag: '经典回顾',
    color: 'from-primary-500/15 to-secondary-500/15',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            四大精选蜜桃动漫在线专题，一站式探索精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="relative group cursor-pointer rounded-2xl overflow-hidden border border-background-200/60"
            >
              <div className="relative w-full aspect-[16/9]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${item.color} via-transparent to-transparent`}></div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-background-950/10 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-semibold rounded-full mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 mb-1 font-medium">{item.subtitle}</p>
                <p className="text-xs text-background-50/60 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}